var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0074 7.8223C10.5488 8.75131 9.92821 9.67759 9.29234 10.5088C8.65846 11.3374 8.02242 12.0547 7.54403 12.5654C7.48046 12.6333 7.41976 12.6974 7.3623 12.7576C7.30485 12.6974 7.24415 12.6333 7.18058 12.5654C6.70218 12.0547 6.06615 11.3374 5.43227 10.5088C4.7964 9.67759 4.17577 8.75131 3.71726 7.8223C3.25401 6.88369 2.9873 6.00417 2.9873 5.25C2.9873 2.83375 4.94606 0.875 7.3623 0.875C9.77855 0.875 11.7373 2.83375 11.7373 5.25C11.7373 6.00417 11.4706 6.88369 11.0074 7.8223ZM7.3623 14C7.3623 14 12.6123 9.0245 12.6123 5.25C12.6123 2.35051 10.2618 0 7.3623 0C4.46281 0 2.1123 2.35051 2.1123 5.25C2.1123 9.0245 7.3623 14 7.3623 14Z",
    fill: "black",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3623 7C6.39581 7 5.6123 6.2165 5.6123 5.25C5.6123 4.2835 6.39581 3.5 7.3623 3.5C8.3288 3.5 9.1123 4.2835 9.1123 5.25C9.1123 6.2165 8.3288 7 7.3623 7ZM7.3623 7.875C8.81205 7.875 9.9873 6.69975 9.9873 5.25C9.9873 3.80025 8.81205 2.625 7.3623 2.625C5.91256 2.625 4.7373 3.80025 4.7373 5.25C4.7373 6.69975 5.91256 7.875 7.3623 7.875Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.da75406dcb357eb639712efa94c2ca17.svg";
export { ForwardRef as ReactComponent };